module.exports = __webpack_public_path__ + "img/800_2.12388196.svg";